// components/wishlist/WishlistSkeleton.tsx
const WishlistSkeleton = () => (
  <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white pb-20">
    <div className="container-custom max-w-7xl mx-auto px-4 py-8">
      {/* Header Skeleton */}
      <div className="mb-8">
        <div className="h-10 bg-gray-200 rounded-xl w-48 mb-2 animate-pulse"></div>
        <div className="h-4 bg-gray-200 rounded-lg w-64 animate-pulse"></div>
      </div>

      {/* Grid Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <div
            key={i}
            className="bg-white rounded-3xl shadow-sm overflow-hidden animate-pulse"
          >
            {/* Image skeleton */}
            <div className="aspect-[3/4] bg-gray-200"></div>
            {/* Content skeleton */}
            <div className="p-4 space-y-3">
              <div className="h-5 bg-gray-200 rounded w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
              <div className="h-6 bg-gray-200 rounded w-1/3"></div>
              <div className="h-10 bg-gray-200 rounded-xl"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default WishlistSkeleton;